import { useMemo } from "react";
import { useSendBulkWhatsappMessage, useOptInInfluencersWhatsapp, useCustomDeliverables } from "../../hooks/usePlanSummary";
import WhatsAppTemplateSendDialog from "../whatsapp/WhatsAppTemplateSendDialog";
import DeliverablePickerButton from "./DeliverablePickerButton";

// Plans page bulk send: the shared dialog, plus the deliverables picker on the one variable the
// template designates for it (set in the Template Builder — see deliverablesVariableIndex).
function WhatsAppBulkSendModal({ open, onClose, planId, planName, selectedIds }) {
  const { data: customDeliverables } = useCustomDeliverables();
  const sendMutation = useSendBulkWhatsappMessage(planId);
  const optInMutation = useOptInInfluencersWhatsapp(planId);
  const recipientIds = useMemo(() => Array.from(selectedIds), [selectedIds]);

  // Clamped against variableCount too, defending against a stale index rather than trusting it.
  const deliverablesAdornment = (i, template, variableCount, setVariableAt) => {
    const idx = template.deliverablesVariableIndex;
    if (!(idx >= 1 && idx <= variableCount && i + 1 === idx)) return null;
    return <DeliverablePickerButton deliverables={customDeliverables || []} onInsert={(joined) => setVariableAt(i, joined)} />;
  };

  return (
    <WhatsAppTemplateSendDialog
      open={open}
      onClose={onClose}
      planName={planName}
      recipientIds={recipientIds}
      noun="influencer"
      onOptIn={() => optInMutation.mutateAsync(recipientIds)}
      sendChunk={(influencerIds, body) => sendMutation.mutateAsync({ influencerIds, ...body })}
      variableAdornment={deliverablesAdornment}
    />
  );
}

export default WhatsAppBulkSendModal;
